function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 18,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 22,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 24,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 26,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 32,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 34,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 36,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 38,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 40,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 42,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 44,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 46,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 50,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 52,
  width: 1,
  height: 36,
  fill: "#003854"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  x: 54,
  width: 1,
  height: 36,
  fill: "#003854"
});

var SvgBarcodeMeireles = function SvgBarcodeMeireles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 36,
    viewBox: "0 0 55 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBarcodeMeireles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/barcode_meireles.d565716b.svg";
export { ForwardRef as ReactComponent };